import { CapoPlugin } from "/home/forge/demo.jmi.cloud/apps/partner/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];